import React from "react";
import "./summercampsblock3.css"; // if you have styling

const SummerCampsBlock3 = ({
  image,
  name1,
  description1,
  name2,
  description2,
  order,
  
}) => {
  return (
    <div className={`summercampsblockdetails-ss-block-ui ${order}`}>
      {/* Content */}
      <div className="ssb-cnt">
        <div className="ssb-title">
          <h2 className="text-clip">{name1}</h2>
        </div>

        <div className="ssb-desc">
          <p className="text-clip" style={{ marginBottom: "20px" }}>
            {description1}
          </p>
        </div>
        <div className="ssb-desc">
          <p className="text-clip" style={{ marginBottom: "20px" }}>
            {description2}
          </p>
        </div>
        <hr />

        <div className="ssb-title">
          <h2 className="text-clip">{name2}</h2>
        </div>

        <div className="ssb-desc events-details">
          <div className="start-time-con">
            <label className="text-clip">Start Time</label>
            <p className="text-clip">09:00 a.m.</p>
          </div>
          <div className="end-time-con">
            <label className="text-clip">End Time</label>
            <p className="text-clip">03:30 p.m.</p>
          </div>
          <div className="phone-con">
            <label className="text-clip">Phone</label>
            <p className="text-clip">646.450.7572</p>
          </div>
          <div className="email-con">
            <label className="text-clip">Email</label>
            <p className="text-clip">ShootinSchool@gmail.com</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummerCampsBlock3;
